export const readAssignments = (employee) => {
  const rows = Array.isArray(employee?.companyAssignments) ? employee.companyAssignments : [];
  const normalized = rows
    .map((row) => ({
      companyId: String(row.companyId?._id || row.companyId || ''),
      companyName: row.companyName || row.companyId?.name || '',
      department: row.department || '',
      region: row.region || ''
    }))
    .filter((row) => row.companyId || row.companyName);

  if (normalized.length) return normalized;
  if (!employee?.companyId && !employee?.company) {
    return [{ companyId: '', companyName: '', department: '', region: '' }];
  }
  return [{
    companyId: String(employee.companyId?._id || employee.companyId || ''),
    companyName: employee.company || '',
    department: employee.department || '',
    region: employee.region || ''
  }];
};

export const formatAssignmentSummary = (employee) => readAssignments(employee)
  .map((row) => [row.companyName || row.company, row.department, row.region].filter(Boolean).join(' · '))
  .filter(Boolean)
  .join(' | ');
